import React from 'react';
import { observer } from 'mobx-react';
import { ThemeStore } from '@gamiphy/loyalty-station-desktop/store/theme';
import { CoreStore } from '@gamiphy/loyalty-station-desktop/store/core';
import { Box, ClickAwayListener } from '@mui/material';
import { AppWelcomeGiftStore } from '@gamiphy/loyalty-station-desktop/store/appWelcomeGift';
import { UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { useResizeDetector } from 'react-resize-detector';
import { FramePortal } from '@gamiphy/loyalty/components/framePortal';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import { getThemeFontStyleSheets, useLSTheme } from '@gamiphy/loyalty/theme';
import WelcomeGiftNotification from './WelcomeGiftNotification';

const WelcomeGiftNotificationFrame: React.FC = observer(() => {
  const muiTheme = useLSTheme({
    dir: AppStore.dir,
    coretavaTheme: ThemeStore.theme,
  });
  const [frameHeight, setFrameHeight] = React.useState<number>();

  const {
    height,
    ref,
  } = useResizeDetector();

  React.useEffect(() => {
    if (height) {
      setFrameHeight(height);
    }
  }, [height]);

  return !CoreStore.initialized ? null : (
    <ClickAwayListener onClickAway={() => UiStore.closeWelcomeGiftNotification()}>
      <FramePortal
        stylesheets={getThemeFontStyleSheets(ThemeStore.theme)}
        theme={muiTheme}
        sx={{ height: frameHeight }}
        dir={AppStore.dir}
      >
        <Box ref={ref}>
          {AppWelcomeGiftStore.welcomeGift && (
            <WelcomeGiftNotification welcomeGift={AppWelcomeGiftStore.welcomeGift} />
          )}
        </Box>
      </FramePortal>
    </ClickAwayListener>
  );
});

export default WelcomeGiftNotificationFrame;
